import Vue from "vue";
import VueRouter from "vue-router"

import Home from "@/components/home/Home"
import NotFound from "@/components/home/NotFound"
import Login from "@/components/login/Login"
import Recovery from "@/components/login/Recovery"
import Projects from "@/components/projects/Projects"
import UO from '@/components/uo/UO'
import Department from '@/components/departments/Department'
import BusinessUnit from '@/components/businessUnit/BusinessUnit'
import ProjectType from '@/components/projectTypes/ProjectType'
import Customers from '@/components/customers/Customer'
import Users from '@/components/users/Users'
//bid
import TipoContrato from '@/components/BID/tiposContrato/TipoContrato'
import TipoServico from '@/components/BID/tiposServico/TipoServico'
import Moedas from '@/components/BID/moedas/Moedas'
import Cotacoes from '@/components/BID/moedas/Cotacoes'
import TarefasPadraoList from '@/components/BID/tarefasPadrao/TarefasPadraoList'
import Gerenciamento from '@/components/BID/gerenciamento/Gerenciamento'

// bid / relatorios
import EAP from "@/components/BID/relatorios/EAP"

//global
import { userKey } from "@/global"

Vue.use(VueRouter);

const routes = [
  {
    name: "home",
    path: "/home",
    component: Home,
    meta: { requiresAuth: true, title: "Base de Teste" }
  },
  {
    name: "home2",
    path: "/",
    component: Home,
    meta: { requiresAuth: true, title: "Base de Teste" }
  },  
  {
    name: "projects",
    path: "/projects",
    component: Projects,
    meta: { requiresAuth: true }
  },
  {
    name: "uo",
    path: "/uo",
    component: UO,
    meta: { requiresAuth: true }
  },
  {
    name: "deps",
    path: "/deps",
    component: Department,
    meta: { requiresAuth: true }
  },
  {
    name: "bu",
    path: "/bu",
    component: BusinessUnit,
    meta: { requiresAuth: true }
  },
  {
    name: "projectTypes",
    path: "/projectTypes",
    component: ProjectType,
    meta: { requiresAuth: true }
  },
  {
    name: "customers",
    path: "/customers",
    component: Customers,
    meta: { requiresAuth: true }
  },
  {
    name: "users",
    path: "/users",
    component: Users,
    meta: { requiresAuth: true }
  },
  {
    name: "login",
    path: "/login",
    component: Login,
  },
  {
    name: "recovery",
    path: "/recovery",
    component: Recovery,
  },
  // BID
  {
    name: "tiposContrato",
    path: "/bid/tiposcontrato",
    component: TipoContrato,
    meta: { requiresAuth: true }
  },
  {
    name: "tiposServico",
    path: "/bid/tiposservico",
    component: TipoServico,
    meta: { requiresAuth: true }
  },

  {
    name: "moedas",
    path: "/bid/moedas",
    component: Moedas,
    meta: { requiresAuth: true }
  },
  {
    name: "cotacoes",
    path: "/bid/cotacoes",
    component: Cotacoes,
    meta: { requiresAuth: true }
  },  
  {
    name: "tarefaspadrao",
    path: "/bid/tarefasPadrao",
    component: TarefasPadraoList,
    meta: { requiresAuth: true }
  },  
  {
    name: "gerenciamento",
    path: "/bid/gerenciamento",
    component: Gerenciamento,
    meta: { requiresAuth: true }
  },  
  {
    name: "eap",
    path: "/bid/relatorios/eap",
    component: EAP,
    meta: { requiresAuth: true }
  },  

  { path: '*', component: NotFound }
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const json = localStorage.getItem(userKey);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const user = JSON.parse(json);
    user ? next() : next({ path: "/login" });
  } else {
    next();
  }
});

export default router;
